var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-management',{attrs:{"title":"소속정보 관리"}},[_c('div',{staticClass:"lab-info-management-content"},[_c('lab-info'),_c('member-management')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }